import { render, staticRenderFns } from "./ShowroomWsDataTableWithTitle001.vue?vue&type=template&id=048b1a62"
import script from "./ShowroomWsDataTableWithTitle001.vue?vue&type=script&lang=js"
export * from "./ShowroomWsDataTableWithTitle001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports